import { slice } from './slice';

const { reducer, actions } = slice;

export const { reset: userUpdateReset } = actions;

export * from './thunks';
export * as userUpdateSelectors from './selectors';

export default reducer;
